@import '../../style/index';

:host {
  .social {
    display: inline-flex;
    align-items: center;
    gap: 1rem;

    p {
      @include copy-secondary();

      margin-top: 0;
      margin-bottom: 0;
      color: var(--colors-basic-white);
    }

    &__icons {
      display: flex;
      gap: 0.5rem;

      a {
        display: flex;
        cursor: pointer;
      }

      img {
        width: 20px;
        height: 20px;
      }
    }

    &__icon {
      background-color: var(--colors-dark-medium);
      padding: 0.3rem;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        background-color: var(--colors-dark-light);
      }
    }
  }
}
